module.exports = __webpack_public_path__ + "img/dp-dy-sh6.57560668.png";